import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "severityInput",
    "severityBtn",
    "screenshotField",
    "screenshotRequired",
    "submitBtn"
  ]

  connect() {
    this.updateScreenshotRequired()
  }

  selectSeverity(event) {
    event.preventDefault()
    const severity = event.params.severity
    this.severityInputTarget.value = severity

    this.severityBtnTargets.forEach((btn) => {
      const active = btn.dataset.severity === severity
      btn.classList.toggle("ring-2", active)
      btn.classList.toggle("ring-offset-1", active)
      btn.classList.toggle("scale-105", active)
      btn.classList.toggle("opacity-60", !active)
    })

    this.updateScreenshotRequired()
  }

  updateScreenshotRequired() {
    const severity = this.severityInputTarget.value
    const required = severity === "critical" || severity === "high"

    if (this.hasScreenshotFieldTarget) {
      this.screenshotFieldTarget.required = required
    }

    if (this.hasScreenshotRequiredTarget) {
      this.screenshotRequiredTarget.classList.toggle("hidden", !required)
    }
  }
}
